import type { AutoGeneratorForFormModel } from "@/components/features/_model/types";

import type { ZodError, z } from "zod";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ZodSchemaType<Z> = z.ZodType<Z, any, Z>;

/**
 *
 * @description InputModel と ZodSchema を受け取り、バリデーションを実行する。
 *
 */
export const validator = <I, E, Q, Z>(
	inputModel: AutoGeneratorForFormModel<I, E, Q>["InputModel"],
	zodSchema: ZodSchemaType<Z>,
): ZodError<Z> | undefined => {
	const validated = zodSchema.safeParse(inputModel);
	const error = validated.success ? undefined : validated.error;
	return error;
};
